export default __webpack_public_path__ + "static/media/connect_wallet.d4841551.png";